const SvgComponent = () => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 6.94C16.4896 6.84813 16.4695 6.75763 16.44 6.67V6.58C16.3919 6.47718 16.3278 6.38267 16.25 6.3L10.25 0.3C10.1673 0.222216 10.0728 0.158081 9.97 0.11H9.88C9.77841 0.0517412 9.66622 0.0143442 9.55 0H3.5C2.70435 0 1.94129 0.316071 1.37868 0.87868C0.816071 1.44129 0.5 2.20435 0.5 3V17C0.5 17.7956 0.816071 18.5587 1.37868 19.1213C1.94129 19.6839 2.70435 20 3.5 20H13.5C14.2956 20 15.0587 19.6839 15.6213 19.1213C16.1839 18.5587 16.5 17.7956 16.5 17V7C16.5 7 16.5 7 16.5 6.94ZM10.5 3.41L13.09 6H11.5C11.2348 6 10.9804 5.89464 10.7929 5.70711C10.6054 5.51957 10.5 5.26522 10.5 5V3.41ZM14.5 17C14.5 17.2652 14.3946 17.5196 14.2071 17.7071C14.0196 17.8946 13.7652 18 13.5 18H3.5C3.23478 18 2.98043 17.8946 2.79289 17.7071C2.60536 17.5196 2.5 17.2652 2.5 17V3C2.5 2.73478 2.60536 2.48043 2.79289 2.29289C2.98043 2.10536 3.23478 2 3.5 2H8.5V5C8.5 5.79565 8.81607 6.55871 9.37868 7.12132C9.94129 7.68393 10.7044 8 11.5 8H14.5V17Z"
        fill="black"
      />
    </svg>
  )
}

export default SvgComponent
